import { useState, useEffect } from 'react';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

export const useSubscription = () => {
  const { user } = useAuth();
  const [entitlements, setEntitlements] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchEntitlements = async () => {
      try {
        const response = await api.get('/api/v1/tenant/billing/entitlements');
        setEntitlements(response.data || response);
      } catch (error) {
        console.error('Failed to fetch entitlements', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEntitlements();
  }, []);

  const hasFeature = (featureKey) => {
    // Super Admin and Admin roles have access to all features
    if (user?.roles_list?.some(r => ['super_admin', 'admin'].includes(r))) {
      return true;
    }
    if (!entitlements) return true;
    return entitlements[featureKey]?.enabled === true;
  };

  const getLimit = (featureKey) => {
    if (!entitlements) return 0;
    return entitlements[featureKey]?.limit || 0;
  };

  return {
    entitlements,
    isLoading,
    hasFeature,
    getLimit
  };
};
